export default "/images/vendor/flag-icons/flags/4x3/om.svg?e32ff9c35c4efac64638cd71377ecf73";